import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { memo } from 'react';
import { TextInput } from 'react-native';

/** A count or a date typed into the range picker. */
export const RangeTextInput = memo(
  ({
    label,
    value,
    placeholder,
    width,
    numeric,
    onChange,
    onCommit,
  }: {
    label: string;
    value: string;
    placeholder?: string;
    width: number;
    numeric?: boolean;
    onChange: (text: string) => void;
    /** Typing finished: the field lost focus or was submitted. */
    onCommit?: () => void;
  }) => {
    const { rpx } = useResponsiveContext();
    return (
      <TextInput
        accessibilityLabel={label}
        value={value}
        onChangeText={onChange}
        onBlur={onCommit}
        onSubmitEditing={onCommit}
        placeholder={placeholder}
        placeholderTextColor={aiColors.mutedForeground}
        keyboardType={numeric ? 'number-pad' : 'numbers-and-punctuation'}
        maxLength={numeric ? 3 : 10}
        style={{
          width: rpx(width),
          height: rpx(32),
          paddingHorizontal: rpx(10),
          borderRadius: rpx(8),
          borderWidth: 1,
          borderColor: aiColors.border,
          backgroundColor: aiColors.input,
          color: aiColors.foreground,
          fontSize: rpx(12),
        }}
      />
    );
  },
);
